import { message } from 'ant-design-vue';

import { Octokit } from '@octokit/rest';

const octokit = new Octokit({
  // TODO: this app should go behind company firewall
  auth: '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'
});

const org = process.env.VUE_APP_GITHUB_ORG;
const repos: any[] = [
  { name: 'analytic-launcher', type: 'backend', lang: 'go' },
  { name: 'satellite-service', type: 'backend', lang: 'go' },
  { name: 'product-manager', type: 'backend', lang: 'go' },

  { name: 'vtserver', type: 'backend', lang: 'node' },

  { name: 'viewer', type: 'ui', lang: 'vue' },
  { name: 'auth-service', type: 'ui', lang: 'vue' },
  { name: 'shape-manager', type: 'ui', lang: 'vue' },
  { name: 'deploy-manager', type: 'ui', lang: 'vue' },
];

repos.forEach((repo) => {
  repo.prs = [];
  repo.dev = {};
  repo.prod = { diff: { commits: [] } };
});

class GithubApi {
  static async getAllData(): Promise<any[]> {
    const allRequests = [];
    for (let i = 0; i < repos.length; i++) {
      const repo = repos[i];
      const calls = [];
      // get PRs info
      calls.push(octokit.pulls.list({ owner: org, repo: repo.name }));
      // get dev commits
      calls.push(
        octokit.repos.getBranch({
          owner: org,
          repo: repo.name,
          branch: 'master'
        })
      );
      // get releases for prod
      calls.push(
        octokit.repos.getLatestRelease({
          owner: org,
          repo: repo.name,
          branch: 'master'
        })
      );
      allRequests.push(Promise.all(calls));
    }

    const data = await Promise.all(allRequests).catch(GithubApi.handleError);
    const diffRequestsProd = [];
    for (let i = 0; i < repos.length; i++) {
      const repo = repos[i];
      repo.prs = data[i][0].data;
      repo.dev = data[i][1].data;
      repo.prod = data[i][2].data;

      if (!repo.prod) {
        repo.prod.newTag = 'v0.0.1'
      } else {
        const lastTag = repo.prod.tag_name.split('.');
        const lastDigit = +lastTag[2];
        repo.prod.newTag = lastTag[0] + '.' + lastTag[1] + '.' + (lastDigit + 1);
      }

      // get diffs
      diffRequestsProd.push(
        octokit.repos.compareCommits({
          owner: org,
          repo: repo.name,
          base: repo.prod.tag_name,
          head: 'master'
        })
      );
    }

    const diffData = await Promise.all(diffRequestsProd);
    for (let i = 0; i < repos.length; i++) {
      const repo = repos[i];
      repo.prod.diff = diffData[i].data;
    }

    // console.log(repos);
    return repos;
  }

  static handleError(serviceError: any, clientError = 'something went wrong'): void {
    let serviceErrorMsg = '';
    if (serviceError.response) {
      serviceErrorMsg = `${serviceError.message}, statusCode: ${serviceError.response.status}`;
    } else {
      serviceErrorMsg = serviceError.message;
    }

    message.error((createElement) => {
      return createElement('span', [
        createElement('span', clientError),
        createElement('br'),
        createElement('span', serviceErrorMsg)
      ]);
    }, 5);

    throw serviceError;
  }
}

export default GithubApi;
